export default "__VITE_ASSET__13LhKqrL__"